module.exports = __webpack_public_path__ + "img/pmi_chapter_mauritius_logo.74c7c9f0.webp";